import { icons } from 'src/assets/iconDef/icon.def';

export const queueViewMenuDef = [
    {
        name: 'menu.queue_view',
        icon: 'fa fa-calendar',
        children: [

            {
                name: 'menu.wing_queue',
                resource: 'wing_queue',
                icon: 'fa fa-superpowers',
                url: 'wing_queue',
                auto_crud: true,
                breadcrumb: 'Queue Master',
                check_permission: false
            },
            {
                name: 'menu.view_queue',
                icon: 'fa fa-calendar',
                resource: 'queue-view',
                url: 'queue-view',
                auto_crud: false,
                breadcrumb: 'Queue View',
                check_permission: false
            },
            {
                // token_queue
                name: 'menu.token_queue',
                resource: 'token_queue',
                icon: 'fa fa-superpowers',
                url: 'token_queue',
                auto_crud: true,
                breadcrumb: 'Token Queue',
                check_permission: false
            },
            {
                name: 'menu.view_queue',
                icon: 'fa fa-calendar',
                resource: 'token-view',
                url: 'token-view',
                auto_crud: false,
                breadcrumb: 'Token View',
                check_permission: false
            },
            {
                name: 'menu.desk_log',
                resource: 'desk_log',
                icon: 'fa fa-superpowers',
                url: 'desk_log',
                auto_crud: true,
                breadcrumb: 'Desk Log',
                check_permission: false
            },
            {
                name: 'menu.token_queue_location',
                resource: 'token_queue_location',
                icon: 'fa fa-superpowers',
                url: 'token_queue_location',
                auto_crud: true,
                breadcrumb: 'Queue Location'
            },
            {
                name: 'menu.qms_detail_report',
                resource: 'qms_detail_report',
                icon: 'fa fa-superpowers',
                url: 'qms_detail_report',
                auto_crud: true,
                breadcrumb: 'QSM Report'
            },

        ]
    },

]
